import { CustomerEdit } from "types/customer"

export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i

const EMAIL_CHAR_REGEX = /[^A-Za-z0-9@._%+-]/g

export const sanitizeEmailInput = (value: string) =>
  value.replace(EMAIL_CHAR_REGEX, "")

export const isValidEmail = (value: string | null | undefined) =>
  !value || EMAIL_REGEX.test(value)

/** Every email field on the new/edit customer form (main, contacts, extra rows). */
export const customerFormEmailsAreValid = (
  values: Pick<CustomerEdit, "email" | "contacts" | "primary_contact_info">
) => {
  if (!isValidEmail(values.email)) return false

  for (const contact of values.contacts || []) {
    if (!contact) continue
    if (!isValidEmail(contact.email)) return false
    for (const row of contact.contact_info || []) {
      if (row.contact_type === "email" && !isValidEmail(row.contact_value)) {
        return false
      }
    }
  }

  for (const row of values.primary_contact_info || []) {
    if (row.contact_type === "email" && !isValidEmail(row.contact_value)) {
      return false
    }
  }

  return true
}